import { Skeleton } from "@/components/ui/skeleton";

export const DiscoverWidgetUserRowSkeleton = ({
  count = 10,
}: {
  count?: number;
}) => {
  return Array.from({ length: count }, (_, index) => (
    <div key={index} className="flex w-full items-center justify-between p-2.5">
      <div className="flex grow items-center gap-2">
        <Skeleton className="size-8 shrink-0 rounded-full" />
        <div className="flex grow flex-col gap-1">
          <Skeleton className="h-3.5 w-[92px]" />
          <Skeleton className="h-3 w-[72px]" />
        </div>
      </div>
      <div className="flex flex-col items-end gap-1">
        <Skeleton className="h-3.5 w-[64px]" />
        <Skeleton className="h-3 w-[44px]" />
      </div>
    </div>
  ));
};
